namespace Matrix.Administration {
    export interface RolePermissionSetRow {
        RoleName?: string;
        PermissionSetCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        RoleNameRowId?: number;
        PermissionSetName?: string;
        PermissionSetDefaultPermissions?: string;
    }

    export namespace RolePermissionSetRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Administration.RolePermissionSet';
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            RoleName = "RoleName",
            PermissionSetCode = "PermissionSetCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            RoleNameRowId = "RoleNameRowId",
            PermissionSetName = "PermissionSetName",
            PermissionSetDefaultPermissions = "PermissionSetDefaultPermissions"
        }
    }
}
